

import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class EqifyMenuItem extends Vue {
  @Prop() to?: string
}

